import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faFacebookF } from "@fortawesome/free-brands-svg-icons";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import { faX } from "@fortawesome/free-solid-svg-icons";
import "../../src/Styles/artistDetails.css";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import { ArtistContext } from "../Contexts/ArtistContext";
import ReactGA from "react-ga4";
import Loading from "./Loading";

import Aos from "aos";
import "aos/dist/aos.css";

const ArtistDetails = () => {
  const { artistId } = useParams();
  const { getArtist } = useContext(ArtistContext);
  const [artist, setArtist] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    Aos.init({ duration: 100 });
  }, []);

  useEffect(() => {
    const fetchArtist = async () => {
      try {
        const artistData = await getArtist(artistId);
        setArtist(artistData);
        ReactGA.send({
          hitType: "View Artist",
          page: window.location.pathname,
        });
        // Google analytics
        if (artistData && artistData.name) {
          ReactGA.event({
            category: "Artist",
            action: "Profile Viewed",
            label: artistData.name,
            value: artistData.artworks.length,
          });
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchArtist();
  }, [artistId]);

  if (loading) return <Loading />;
  if (error) return <div>Error: {error}</div>;
  return (
    <div className="ArtistPage">
      <NavBar />
      <div className="section1" data-aos="fade-up" data-aos-duration="500">
        <div className="left">
          <img
            src={`${artist.image}`}
            alt={`${artist.name} profile`}
          />
        </div>
        <div className="right">
          <h2>{artist.name}</h2>
          <p>{artist.description}</p>
          <div className="icons">
            {/* Icons go here */}
            <a
              href={artist.x}
              className="flex items-center justify-center w-10 h-10 border border-white bg-black text-white rounded-full"
            >
              <FontAwesomeIcon icon={faX} className="text-base" />
            </a>
            <a
              href={artist.instagram}
              className="flex items-center justify-center w-10 h-10 border border-white bg-black text-white rounded-full"
            >
              <FontAwesomeIcon icon={faInstagram} className="text-base" />
            </a>
            <a
              href={artist.facebook}
              className="flex items-center justify-center w-10 h-10 border border-white bg-black text-white rounded-full"
            >
              <FontAwesomeIcon icon={faFacebookF} className="text-base" />
            </a>
            <a
              href={artist.linkedin}
              className="flex items-center justify-center w-10 h-10 border border-white bg-black text-white rounded-full"
            >
              <FontAwesomeIcon icon={faLinkedinIn} className="text-base" />
            </a>
          </div>
        </div>
      </div>
      <div className="section2">
        <h2 data-aos="fade-left" data-aos-duration="1000">
          Works of {artist.name}
        </h2>
        <div className="Cards">
          {artist.artworks.map((artwork, index) => (
            <div
              className="artwork"
              key={artwork._id}
              data-aos="fade-up-right"
              data-aos-duration="500"
              data-aos-delay={index * 500}
            >
              <a href={`/product/${artwork._id}`}>
                <img
                  src={`${artwork.artImageCover}`}
                  alt={artwork.artName}
                />
              </a>
              <h4>{artwork.artName}</h4>
              <p>
                ${artwork.editions[0].price}
              </p>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ArtistDetails;
